export default __webpack_public_path__ + "static/media/print-document.5cf802cd.svg";